/* eslint-disable no-underscore-dangle */
import React from 'react'

import { ExpandableCell } from './ExpandableCell'

export type RegionCellProps = {
  cellProps: {
    original: {
      regions: RegionItemProps[]
    }
  }
}

export type RegionItemProps = {
  name: string
}

export const regionFilter = (filterItem: any, data: any) => {
  const filter = filterItem.value.toLowerCase()
  const { regions } = data._original
  const regionNames = regions.map((region: RegionItemProps) =>
    region.name.toLowerCase()
  )
  let result = false
  if (
    regionNames.length &&
    regionNames.some((region: any) => region.includes(filter))
  )
    result = true
  return result
}

export const RegionCell = ({
  cellProps: {
    original: { regions }
  }
}: RegionCellProps) => {
  if (!regions) return null
  const regionNames = regions.map(({ name }) => name)
  return <ExpandableCell defaultLength={6} items={regionNames} />
}
